import React from 'react';
import {Route, Switch} from 'react-router-dom';
import { MenuList, AdminMenuList } from './components/parts/index';
import { Home, Report, UserAccount, NewsManage, AccountManage, Logout, NotFound} from './components/pages/index';

const SystemRoute = (props) => {
    return (
      <>
        <Switch>
          <Route path = "/" component={MenuList} />
        </Switch>
        <Switch>
          <Route exact path = "/Home" component={Home} />
          <Route exact path = "/Report" component={Report} />
          <Route exact path = "/AccountEdit" component={UserAccount} />
          <Route 
            exact path = "/ReportBase" 
            render={props => <Report pathName="ReportBase" {...props} />} />
          <Route
            exact path = "/ReportItem" 
            render={props => <Report pathName="ReportItem" {...props} />} />
          <Route 
            exact path = "/Logout"
            render={props => <Logout pathName="Logout" {...props} />} />
          <Route path = "/" component={NotFound} />
        </Switch>
      </>
    )
}

export default SystemRoute;